export type ShellTheme = 'dark' | 'light';

export const RUBY = '#DC143C';
export const RUBY_DEEP = '#9F1239';

export const PALETTE: Record<ShellTheme, { ground: string; surface: string; ink: string; muted: string; line: string; quiet: string }> = {
  dark: { ground: '#09090b', surface: '#18181b', ink: '#FFFFFF', muted: '#A8A29E', line: '#27272a', quiet: '#27272a' },
  light: { ground: '#FFFFFF', surface: '#FFFFFF', ink: '#1C1917', muted: '#78716C', line: '#E7E5E4', quiet: '#F5F5F4' },
};

export const FONT = '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif';
